import type { Meta, StoryObj } from "@storybook/react";

import { fakeGroupClassSeries } from "@/__mocks__/groupClassSeries";
import type { GroupClassCardProps } from "@/ui/components/groupClasses/series/GroupClassCard";
import GroupClassCard from "@/ui/components/groupClasses/series/GroupClassCard";
import { IllustrationName } from "@/ui/theme/icons/illustrations/groupClasses";

const example = fakeGroupClassSeries();

const StoryMeta: Meta<GroupClassCardProps> = {
  title: "Components/Group Classes/Group Class Card",
  component: GroupClassCard,
  argTypes: {
    description: { control: "text" },
    iconName: {
      control: "select",
      options: Object.values(IllustrationName),
    },
    isCore: { control: "boolean" },
    isRegistered: { control: "boolean" },
    nextDateString: { control: "text" },
    numberOfOptions: { control: "number" },
    onSelect: { action: "selected" },
    recurrenceString: { control: "text" },
    size: { control: "radio", options: ["default", "small"] },
    title: { control: "text" },
  },
  args: {
    description:
      "A guided group to help you gradually explore new foods, build confidence at mealtimes, and expand your relationship with eating.",
    groupClassExternalId: example.groupClassExternalId,
    iconName: example.iconName.toLowerCase(),
    title: "DBT Skills for Teens",
  },
};

type Story = StoryObj<GroupClassCardProps>;

const RegisteredCore: Story = {
  args: {
    isCore: true,
    isRegistered: true,
    nextDateString: "Next on Friday, Apr 7",
    recurrenceString: "Every Fri, 4-4:50 pm",
  },
};

const Unregistered: Story = {
  args: {
    numberOfOptions: 10,
    title: "BIPOC Support",
  },
};

const SingleOption: Story = {
  args: {
    numberOfOptions: 1,
  },
};

const RegisteredNoDescription: Story = {
  args: {
    description: undefined,
    isRegistered: true,
    nextDateString: "Next on Friday, Apr 7",
    recurrenceString: "Every Fri, 4-4:50 pm",
  },
};

const Small: Story = {
  args: {
    numberOfOptions: 10,
    size: "small",
  },
};

export {
  RegisteredCore,
  RegisteredNoDescription,
  SingleOption,
  Small,
  Unregistered,
};
export default StoryMeta;
